import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import React, { useRef, useState, useImperativeHandle, useCallback } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import classNames from 'classnames';
import { Button, Dialog, Icon, Table, TableHeader, TableRow, TableHeaderColumn, TableBody, TableRowColumn, getPreferredProp } from '@unite-us/ui';
import FileUpload from '../../common/FileUpload/FileUpload';
import './PaymentsSupportingDocuments.scss';
import AddCirclePlusButton from '../../common/AddCirclePlusButton';
export var PaymentsSupportingDocuments = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var fieldName = props.fieldName,
    field = props.field,
    label = props.label,
    required = props.required;
  useImperativeHandle(ref, function () {
    return {
      props: props
    };
  });
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    uploadedFiles = _useState2[0],
    setUploadedFiles = _useState2[1];
  var _useState3 = useState({
      filesTooBig: [],
      filesWrongType: [],
      filesTooBigAndWrongType: []
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    rejectedFiles = _useState4[0],
    setRejectedFiles = _useState4[1];
  var _useState5 = useState({}),
    _useState6 = _slicedToArray(_useState5, 2),
    removedFile = _useState6[0],
    setRemovedFile = _useState6[1];
  var fileUploadRef = useRef();
  var deleteAttachmentModal = useRef();
  var fieldValue = field.value || [];

  // Attach file(s) modal action handlers
  var attachDocumentModalHandler = useCallback(function (event) {
    event.preventDefault();
    fileUploadRef.current.openDialog();
  }, []);
  var confirmAttachFiles = useCallback(function () {
    var _context;
    field.onChange(_concatInstanceProperty(_context = []).call(_context, _toConsumableArray(fieldValue), _toConsumableArray(uploadedFiles)));
    setUploadedFiles([]);
    setRejectedFiles({
      filesTooBig: [],
      filesWrongType: [],
      filesTooBigAndWrongType: []
    });
    fileUploadRef.current.closeDialog();
  }, [uploadedFiles, fieldValue]);
  var cancelAttachFiles = useCallback(function () {
    setUploadedFiles([]);
    setRejectedFiles({
      filesTooBig: [],
      filesWrongType: [],
      filesTooBigAndWrongType: []
    });
    fileUploadRef.current.closeDialog();
  }, []);

  // Delete file modal action handlers
  var trashModalHandler = useCallback(function (file) {
    setRemovedFile(file);
    deleteAttachmentModal.current.openDialog();
  }, [removedFile]);
  var confirmRemoveFile = useCallback(function () {
    var removedFileId = removedFile.tempId || removedFile.id;
    var updatedFiles = _filterInstanceProperty(fieldValue).call(fieldValue, function (file) {
      return (file.id || file.tempId) !== removedFileId;
    });
    field.onChange(updatedFiles);
    setRemovedFile({});
    deleteAttachmentModal.current.closeDialog();
  }, [removedFile]);
  var cancelRemoveFile = useCallback(function () {
    setRemovedFile({});
    deleteAttachmentModal.current.closeDialog();
  }, []);
  var invalid = getPreferredProp(props, 'invalid') && getPreferredProp(props, 'touched');
  var headerClass = function headerClass() {
    return classNames(['payments-attachments-metafield-header', 'uppercase font-heavy-font text-xs tracking-wider', required && 'payments-attachments-metafield-header--required', invalid && 'text-validation-red']);
  };
  var emptyAttachmentsClass = function emptyAttachmentsClass() {
    return classNames(['text-dark-blue opacity-50', invalid && 'border-solid border border-validation-red rounded-md']);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "space-y-4",
    "data-testid": "payments-supporting-documents"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between items-center"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
    className: headerClass()
  }, label)), /*#__PURE__*/React.createElement(AddCirclePlusButton, {
    addHandler: attachDocumentModalHandler,
    ariaLabel: "Attach Document",
    className: "payments-attachment-button",
    id: "payments-attachment-button-".concat(fieldName),
    labelText: "Attach Document"
  })), /*#__PURE__*/React.createElement(Dialog, {
    id: "upload-payments-documents",
    modal: true,
    onRequestClose: cancelAttachFiles,
    ref: fileUploadRef,
    title: "Attach Documents",
    actions: /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
      className: "attach-document-dialog__actions--cancel",
      label: "Cancel",
      onClick: cancelAttachFiles
    }), /*#__PURE__*/React.createElement(Button, {
      className: "attach-document-dialog__actions--save",
      label: "Attach",
      "data-testid": "attach-button",
      primary: true,
      disabled: !uploadedFiles.length,
      onClick: confirmAttachFiles,
      style: {
        marginLeft: '12px'
      }
    }))
  }, /*#__PURE__*/React.createElement(FileUpload, {
    rejectedFiles: rejectedFiles,
    setRejectedFiles: setRejectedFiles,
    setUploadedFiles: setUploadedFiles,
    uploadedFiles: uploadedFiles
  })), fieldValue.length ? /*#__PURE__*/React.createElement(Table, null, /*#__PURE__*/React.createElement(TableHeader, null, /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableHeaderColumn, null, "File Name"), /*#__PURE__*/React.createElement(TableHeaderColumn, null, "Date Modified"))), /*#__PURE__*/React.createElement(TableBody, null, _mapInstanceProperty(fieldValue).call(fieldValue, function (fileData) {
    var file = fileData.file || fileData;
    return /*#__PURE__*/React.createElement(TableRow, {
      className: "file-row",
      clickable: false,
      hoverable: false,
      key: fileData.id || fileData.tempId
    }, /*#__PURE__*/React.createElement(TableRowColumn, null, /*#__PURE__*/React.createElement("a", {
      href: fileData.preview,
      rel: "noreferrer",
      target: "_blank",
      className: "text-current-blue"
    }, file.name)), /*#__PURE__*/React.createElement(TableRowColumn, null, new Intl.DateTimeFormat('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    }).format(file.created_at ? new Date(file.created_at) : new Date())), /*#__PURE__*/React.createElement(TableRowColumn, null, /*#__PURE__*/React.createElement(Icon, {
      className: 'text-grey fill-current',
      icon: "IconTrash",
      onClick: function onClick() {
        return trashModalHandler(fileData);
      },
      size: 18,
      ariaLabel: "delete attachment"
    })));
  }))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("p", {
    className: emptyAttachmentsClass()
  }, "No documents have been added to this note."), invalid ? /*#__PURE__*/React.createElement("div", {
    className: "text-validation-red text-xs mt-1"
  }, "Required") : null), /*#__PURE__*/React.createElement(Dialog, {
    id: "delete-attachment-dialog",
    ref: deleteAttachmentModal,
    title: 'Delete attachment',
    modal: true,
    onRequestClose: cancelRemoveFile,
    "data-testid": "delete-attachment-dialog",
    actions: /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
      className: "",
      label: "Cancel",
      onClick: cancelRemoveFile
    }), /*#__PURE__*/React.createElement(Button, {
      className: "",
      label: "Delete Attachment",
      primary: true,
      onClick: confirmRemoveFile,
      style: {
        marginLeft: '12px'
      }
    }))
  }, /*#__PURE__*/React.createElement("p", null, "You are about to remove", /*#__PURE__*/React.createElement("strong", {
    className: "text-action-light-blue"
  }, " ", removedFile.name || get(removedFile, 'file.name', ''), " "), "as an attachment from this service.")));
});
PaymentsSupportingDocuments.propTypes = {
  field: PropTypes.object.isRequired,
  fieldName: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  required: PropTypes.bool
};
PaymentsSupportingDocuments.defaultProps = {
  required: false
};
//# sourceMappingURL=PaymentsSupportingDocuments.js.map